import { createContext, useContext } from "react"

// The dashboard rendered at /dashboard when no :dashboardId route param is present.
export const DEFAULT_DASHBOARD_ID = "default"

// Stable string ID that scopes all dashboard RTK slice lookups. Not state — constant for the
// lifetime of the provider subtree.
const DashboardIdContext = createContext<string>(DEFAULT_DASHBOARD_ID)

export const DashboardIdProvider = DashboardIdContext.Provider

// Reads "default" outside a provider instead of throwing, so most consumers/stories need
// no setup. Stories needing a distinct id must wrap their tree in DashboardIdProvider.
export function useDashboardId(): string {
  return useContext(DashboardIdContext)
}
